








































import Component from 'vue-class-component'
import { Watch, Mixins } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
import HomeNav from 'vuecomponents/home_nav.vue'
import FormatCards from 'vuecomponents/format_cards.vue'
import ButtonList from 'vuecomponents/button_list.vue'
import BaseButton from 'library/v4/components/base-button.vue'
import BaseButtonIcon from 'library/v4/components/base-button-icon.vue'
import LandsideFooter from 'vuecomponents/landside_footer.vue'
import { __ } from 'bits/intl'
import WindowSizeMixin from 'vuemixins/window_size_mixin'
import DarkModeMixin from 'vuemixins/dark_mode_mixin'
import BaseSidebar from 'vuecomponents/base_sidebar.vue'
import MembershipFooter from 'vuecomponents/membership_footer.vue'

const browser = namespace('browser')

@Component({
  components: {
    HomeNav,
    FormatCards,
    ButtonList,
    BaseButton,
    BaseButtonIcon,
    LandsideFooter,
    BaseSidebar,
    MembershipFooter,
  },
})
export default class HomeApp extends Mixins(WindowSizeMixin, DarkModeMixin) {
  @browser.Getter isSmallerThanTabletPortrait
  @browser.Getter isBiggerThanTabletLandscape
  @browser.State os

  get heroClass(): object {
    return {
      'container-mobile': this.isSmallerThanTabletPortrait,
      'container-tablet': !this.isBiggerThanTabletLandscape,
      container: true,
    }
  }

  get signupText(): string {
    if (this.isSmallerThanTabletPortrait) return __('Sign up')
    return __('Sign up for free')
  }

  get signUpButtonVariation(): string {
    return !this.isBiggerThanTabletLandscape ? 'normal' : 'large'
  }

  get isOsSupported(): boolean {
    return this.os !== 'unknown'
  }

  get installAppUrl(): string | undefined {
    if (this.os === 'ios') return 'https://padlet.com/ios-app'
    if (this.os === 'android') return 'https://padlet.com/android-app'
    if (this.os === 'windows') return 'https://www.microsoft.com/en-us/p/padlet/9mtwd1kmhb48'
    if (this.os === 'mac') return 'https://padl.et/mac-app-download'
    return undefined
  }

  get installAppText(): string | undefined {
    if (this.isSmallerThanTabletPortrait) return __('Install app')
    if (this.os === 'ios') return __('Install app')
    if (this.os === 'android') return __('Install app')
    if (this.os === 'windows') return __('Install windows app')
    if (this.os === 'mac') return __('Install mac app')
    return undefined
  }

  get installAppIcon(): string | undefined {
    if (this.os === 'ios') return 'apple'
    if (this.os === 'android') return 'android'
    if (this.os === 'windows') return 'windows'
    if (this.os === 'mac') return 'apple'
    return undefined
  }

  mounted() {
    const bodyElement = document.getElementsByTagName('body')[0]
    if (this.isSmallerThanTabletPortrait) {
      bodyElement.classList.add('mobile')
    }
  }

  @Watch('isSmallerThanTabletPortrait')
  onMobileView() {
    const bodyElement = document.getElementsByTagName('body')[0]

    if (this.isSmallerThanTabletPortrait) {
      bodyElement.classList.add('mobile')
    } else if (!this.isSmallerThanTabletPortrait && bodyElement.classList.contains('mobile')) {
      bodyElement.classList.remove('mobile')
    }
  }
}
